{"name": "web-app", "buildversion": "2.0.31_11052026-083411", "buildTime": "05/11/2026 08:34:19"}